module.exports = __webpack_public_path__ + "static/downloable/formato_solicitud_cambio_via_de_pago.8226bbe.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloable/formatos/formato_solicitud_cambio_via_de_pago.pdf
// module id = AJJu
// module chunks = 1